<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="delivery-lines"
>
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between">
      <h2 class="text--h3"></h2>
      <agr-daterange-picker
        [config]="customDateRangeConfig"
        (change)="onDateRangeChanged($event)"
      ></agr-daterange-picker>
    </div>

    <agr-table data-test="milk-delivery__table" [config]="tableConfig"></agr-table>
  </div>
</agr-page-toolbar>
